import {
  TransactionGetEvent,
  TransactionPostCart,
} from "../Services/Transactions";
import { LoadingContext, ProfileContext } from "../Context";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { BaseRouteParams, CartDetailTypeEnum, EventType } from "../Structures";
import { formatPrice, Toast } from "../Utils";
import { Button, Tag } from "../Components/Base";

const Event = () => {
  const navigate = useNavigate();
  const params = useParams<BaseRouteParams>();
  const { profile } = useContext(ProfileContext);
  const { setLoading } = useContext(LoadingContext);

  // ===============================================================

  const [event, setEvent] = useState<EventType | null>(null);

  // ===============================================================

  const handleAddToCart = () => {
    if (profile.personalVerification && event?.is_active) {
      setLoading(true);
      TransactionPostCart(Number(params.id), CartDetailTypeEnum.EVENT)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            Toast("success", res.message);
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setLoading(false));
    } else {
      Toast("error", "لطفا ابتدا احراز هویت خود را انجام دهید");
    }
  };

  // ===============================================================

  useEffect(() => {
    window.scrollTo(0, 0);
    if (params.id) {
      setLoading(true);
      TransactionGetEvent(params.id)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            setEvent(res.data!);
          } else {
            navigate("/events");
            Toast("error", "پست مورد نظر یافت نشد.");
          }
        })
        .finally(() => setLoading(false));
    } else navigate("/events");
  }, [params.id]);

  // ===============================================================

  return (
    <Fragment>
      <section className="pt-4 pt-md-5">
        <div className="container">
          <div className="row g-4 g-lg-0 justify-content-between">
            <div className="col-lg-5">
              <div className="row g-2">
                <div className="col-12">
                  <div
                    style={{ height: 400 }}
                    className="bg-light d-flex justify-content-center align-items-center rounded-2 glightbox-bg p-4 position-relative"
                  >
                    <img src={event?.thumbnail} alt={event?.title} className="mh-100 rounded-2" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <h1>{event?.title}</h1>
              <p className="mb-4 text-justify">{event?.description}</p>

              <div className="bg-light p-3 rounded-2 mb-3">
                <div className="row g-2">
                  <div className="col-12">
                    <ul className="list-group list-group-borderless">
                      <li className="list-group-item mb-3 py-0">
                        <span>آدرس:</span>
                        <span className="h6 text-justify">
                          {event?.address}
                        </span>
                      </li>
                      <li className="list-group-item mb-3 py-0">
                        <span>تاریخ و ساعت برگزاری:</span>
                        <span className="h6 text-justify">
                          {event?.time} - {event?.date}
                        </span>
                      </li>
                       <li className="list-group-item mb-2 py-0">
                        <span>تاریخ و ساعت پایان ثبت‌نام:</span>
                        <span className="h6 text-justify">
                          {event?.expire_time} - {event?.expire_date}
                        </span>
                      </li>
                      <li
                        style={{ marginBottom: -10 }}
                        className="list-group-item d-flex justify-content-start align-items-center pb-0"
                      >
                        <span className="mb-2">دسته بندی:</span>
                        <span className="h6 d-flex gap-2 align-items-center mb-0">
                          {event?.categories.map((tag, index) => (
                            <Tag tag={tag} key={index} wrapperClass="mb-0" />
                          ))}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {event ? !event?.is_active ? (
                <div className="w-100 mb-3 m-0 alert flex-wrap flex-md-nowrap alert-danger d-flex">
                  <div className="mb-md-0 d-flex align-items-center">
                    <i className="fa fa-info-circle text-danger me-2"></i>
                    زمان شرکت در رویداد به پایان رسیده است.
                  </div>
                </div>
              ) : null : null}

              <div className="row">
                <div className="col-md-6 d-flex justify-content-start gap-2 align-items-center">
                  <h6 className="mb-0">هزینه‌ی رویداد:</h6>
                  <h4 className="text-success mb-0 fw-bold">
                    {formatPrice(event?.price || 0)} تومان
                  </h4>
                </div>

                <div
                  className="col-md-6 mt-4 mt-md-0"
                  style={{ marginRight: "auto" }}
                >
                  <Button
                    onClick={handleAddToCart}
                    btnClass="btn-primary w-100"
                    disabled={!event?.is_active}
                    text="افزودن به سبد"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {event?.contents.length ? (
        <Fragment>
          <div className="container my-5">
            <hr />
          </div>
          <section className="pt-0 pt-lg-5">
            <div className="container">
              <div className="row g-4 justify-content-between">
                <div className="col-12 mt-0">
                  <h3 className="mb-5 fw-bold">توضیحات</h3>

                  {event?.contents.map((content, index) => (
                    <div
                      className="mb-4 row"
                      dir={index % 2 == 0 ? "rtl" : "ltr"}
                      key={content.id}
                    >
                      {content.image ? (
                        <div className="col-12 col-lg-4">
                          <div
                            className="card w-100 mb-3 overflow-hidden d-flex justify-content-center align-items-start"
                            style={{ maxHeight: 250 }}
                          >
                            <img
                              className="h-100 w-100 object-fit-cover rounded-3"
                              src={content.image}
                            />
                          </div>
                        </div>
                      ) : null}
                      <div
                        dir="rtl"
                        className={`col-12 ${content.image ? "col-lg-8" : ""} `}
                      >
                        <h5>{content.title}</h5>
                        <p className="text-justify">{content.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default Event;
